const textInputValidator = (value, setError, setHelperText, charLimit) => {
    console.log(value)//TO DO attention au injection de script
    console.log(setError)
    if (value === '') {
        console.log('ato Erreur')
        setError(true);
        setHelperText('Ce champ est obligatoire.');
        return true;
    } else if (charLimit) {
        if (value.length > charLimit) {
            setError(true);
            setHelperText(`Ce champ ne doit pas dépasser ${charLimit} caractères.`);
            return true;
        } else {
            setError(false);
            setHelperText(' ');
            return false;
        }
    } else {
        setError(false);
        setHelperText(' ');
        return false;
    }
}

export default textInputValidator;
